module.exports = __webpack_public_path__ + "static/img/FIIlogo.df80226.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/FinancialInformationInquiry/img/FIIlogo.svg
// module id = tBJR
// module chunks = 3